import React from 'react';

/**
 * Mãozinha cheia usada como alça de arrastar nas tabelas de ordem.
 *
 * SVG próprio porque o Font Awesome carregado no painel é o 4.7, que só tem a mão
 * em contorno (fa-hand-paper-o) — o desenho pedido é a mão preenchida. Desenho do
 * "hand-paper" sólido do Font Awesome 5 (licença CC BY 4.0).
 */
export default function IconeMao({ tamanho = 18 }) {
    return (
        <svg
            width={tamanho}
            height={tamanho}
            viewBox='0 0 448 512'
            fill='currentColor'
            aria-hidden='true'
            focusable='false'
        >
            <path d='M408.781 128.007C386.356 127.578 368 146.36 368 168.79V256h-8V79.79c0-22.430-18.356-41.212-40.781-40.783C297.488 39.423 280 57.169 280 79v177h-8V40.79C272 18.36 253.644-.422 231.219.007 209.488.423 192 18.169 192 40v216h-8V80.79c0-22.430-18.356-41.212-40.781-40.783C121.488 40.423 104 58.169 104 80v235.992l-31.648-43.519c-12.993-17.866-38.009-21.817-55.877-8.823-17.865 12.994-21.815 38.010-8.822 55.877l125.601 172.705A48 48 0 0 0 172.073 512h197.590c22.274 0 41.622-15.324 46.724-37.006l26.508-112.660a192.011 192.011 0 0 0 5.104-43.975V168c.001-21.831-17.487-39.577-39.218-39.993z'/>
        </svg>
    );
}
